export default {
  // Acciones y confirmaciones genericas
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  close: 'Cerrar',
  confirm_data_message: 'Estás a punto de cambiar tu información ¿Deseas continuar?',

  // Notificaciones de seguridad (contraseña)
  success_password_changes: 'Tu contraseña ha sido modificada. La siguiente vez deberás iniciar sesión con tu nueva contraseña.',

  // Foto de perfil
  change_image: 'Cambiar imágen',
  biometric: {
    section_title: 'Seguridad',
    title_fingerprint: 'Inicio con huella',
    title_face: 'Inicio con Face ID',
    title_generic: 'Inicio con biometría',
    caption_enabled: 'Activo en este dispositivo',
    caption_disabled: 'Desactivado · se activa la próxima vez que entres con contraseña',
    caption_dismissed: 'Desactivado · no se te ofrecerá al entrar con contraseña',
    reoffer: 'Volver a ofrecer',
    reoffer_success: 'Te lo ofreceremos la próxima vez que entres con contraseña',
    dialog_title: '¿Desactivar el inicio biométrico?',
    dialog_message: 'La próxima vez tendrás que entrar con tu usuario y contraseña en este dispositivo.',
    dialog_confirm: 'Desactivar',
    disabled_success: 'Inicio biométrico desactivado en este dispositivo',
    disabled_error: 'No se pudo desactivar el inicio biométrico. Intenta de nuevo.'
  }
}
